/* eslint-disable no-param-reassign */
const mutations = {
  SET_CURRENT_EDITING_MODULE(state, module) {
    state.currentEditingModule = module
  },
  SET_CURRENT_COURSES_EDITING_STATE(state, editingState) {
    state.courseEditingState = editingState
  },
  UPDATE_MODULE_ID(state, moduleID) {
    state.currentModuleID = moduleID
  },
  UPDATE_EDITING_TOPIC(state, topic) {
    state.currentEditingTopic = topic
  },
  UPDATE_CURRENT_TAG_LIST(state, list) {
    state.currentTagList = list
  },
  UPDATE_ORIGINAL_TAG_LIST(state, list) {
    state.originalTagList = list
  },
  UPDATE_DELETED_TAG_LIST(state, list) {
    state.deletedTags = list
  },
  UPDATE_ADDED_TAG_LIST(state, list) {
    state.addedTags = list
  },
  UPDATE_QUESTION_STITCHER_LIST(state, list) {
    state.questionStitcherList = list
  },
  UPDATE_MEGA_JSON(state, list) {
    state.megaJSON = list
  },

  UPDATE_CURRENT_EDITING_READING_OBJECT(state, obj) {
    state.currentEditingReadingObject = obj
  },
  UPDATE_EDITING_QUESTION(state, obj) {
    state.currentEditingQuestion = obj
  },
}

export default mutations
